const shadows = {
  level1: '0 2px 12px 4px rgba(86, 86, 86, 0.08)',
  level2: '0px 4px 12px 4px rgba(86, 86, 86, 0.16)',
  level3: '0px 8px 36px 4px rgba(86, 86, 86, 0.24)',
  level4: '0px 8px 80px 4px rgba(86, 86, 86, 0.32)',
}

export { shadows }
